import React from "react";
import Doctor from "../Assets/doctor-book-appointment.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faCalendarCheck,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate  } from "react-router-dom";
import "../Styles/BookAppointment.css";

function BookAppointment() {
  const navigate = useNavigate();

  const handleBookAppointmentClick = () => {
    navigate("/appointment");
  };

  return (
    <div className="ba-section">
      <div className="ba-image-content">
        <img src={Doctor} alt="Doctor Group" className="ba-image1" />
      </div>

      <div className="ba-text-content">
        <h3 className="ba-title">
          <span>¿Por qué elegirnos?</span>
        </h3>
        <p className="ba-description" style={{ textAlign: 'justify' }}>
        Descubra las razones para elegir Family Insurance Enterprise como su agencia de seguros. Experimente atención experta, 
        conveniencia y soluciones personalizadas, haciendo de su bienestar nuestra principal prioridad. Únase a nosotros en un viaje 
        hacia una mejor salud y una vida más feliz.
        </p>

        <p className="ba-checks ba-check-first">
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#1E8FFD" }} /> Cobertura Personalizada y Accesible
        </p>
        <p className="ba-checks">
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#1E8FFD" }} /> Asistencia Integral en Reclamaciones
        </p>
        <p className="ba-checks">
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#1E8FFD" }} /> Atención Cercana y Dedicada
        </p>
        <p className="ba-checks ba-check-last">
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#1E8FFD" }} /> Beneficios Exclusivos para Clientes
        </p>

       
      </div>
    </div>
  );
}

export default BookAppointment;
